import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { CallAction } from '@gem/call/Model/callModel.types';
import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { callModel } from 'APP/model/model';

export const askAndFinishActiveCall = async (
  channelId: string,
  myId: string,
  deviceId: ProviderUid,
  popupText: string
): Promise<boolean> => {
  const confirmResult = await Tasks.app.showConfirm({
    text: t(popupText),
    primaryText: t('common_yes'),
    secondaryText: t('common_no'),
  });

  if (!confirmResult) {
    return false;
  }

  await callModel.setActionCall({
    action: CallAction.ForceFinish,
    channelId,
    userId: myId,
    deviceId,
  });

  return true;
};
